import axios from 'axios';

export const getBudgets = () => axios(`${process.env.REACT_APP_BUDGET_API_URL}`);

export default { getBudgets };
